import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Subject, Observable } from "rxjs";
import { Router } from "@angular/router";

import { environment } from "src/environments/environment";

const BACKEND_URL = environment.apiUrl + "/ph/";

@Injectable({ providedIn: "root" })
export class PHOrdersService {
  orders: any[] = [];
  private ordersUpdated = new Subject<{ orders: any[], orderCount: number }>();
  private refreshRequested = new Subject<void>();

  constructor(private http: HttpClient, private router: Router) { }

  getRefreshRequestedListener(): Observable<void> {
    return this.refreshRequested.asObservable();
  }

  notifyOrderUpdated(): void {
    this.refreshRequested.next();
  }

  getPHOrdersForManager(ordersPerPage: number, currentPage: number) {
    const requestBody = { ordersPerPage, currentPage };
    this.http.post<{ message: string; orders: any, maxOrders: number }>(`${BACKEND_URL}ordersformanager`, requestBody)
      .subscribe(orderData => {
        // console.log('Response from server:', orderData);
        if (!orderData.orders) {
          return;
        }
        this.orders = orderData.orders;
        // console.log('orders:', this.orders);
        this.ordersUpdated.next({
          orders: [...this.orders],
          orderCount: orderData.maxOrders
        });
      });
  }

  getOrderUpdateListener() {
    return this.ordersUpdated.asObservable();
  }

  cancelOrder(orderId: string): Observable<any> {
    return this.http.put(`${BACKEND_URL}cancelorder/${orderId}`, null);
  }

  /**
   * זיכוי כספי להזמנת PH – רק למנהלי PH.
   * שולח בקשת זיכוי לשרת; השרת מעדכן סטטוס ל-REFUNDED ומחזיר את ההזמנה המעודכנת.
   */
  refundCredit(orderId: string): Observable<{ order: any; status: string }> {
    return this.http.put<{ order: any; status: string }>(`${BACKEND_URL}refund-credit/${orderId}`, {});
  }

  /**
   * זיכוי בנקודות להזמנת PH – מעדכן סטטוס ל-REFUNDED_POINTS.
   */
  refundPoints(orderId: string): Observable<{ order: any; status: string }> {
    return this.http.put<{ order: any; status: string }>(`${BACKEND_URL}refund-points/${orderId}`, {});
  }

  // ====================
}
